/**
 * localStorage Persistence für User Preferences
 * Portal-Grade UX: State bleibt über Sessions erhalten
 */

export type ViewMode = 'grid' | 'list';
export type SortOption = 'relevance' | 'distance' | 'rating' | 'name';
export type CardDensity = 'comfort' | 'compact';

interface UserPreferences {
  viewMode: ViewMode;
  sortBy: SortOption;
  cardDensity: CardDensity;
  location?: {
    label: string;
    lat?: number;
    lng?: number;
    placeId?: string;
    source?: string;
  };
  lastLocation?: string;
  lastLat?: number;
  lastLng?: number;
}

const STORAGE_KEY = 'speiseguru_user_prefs';

export const storage = {
  get: (): Partial<UserPreferences> => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : {};
      if (parsed.cardDensity === 'comfortable') {
        parsed.cardDensity = 'comfort';
      }
      if (!parsed.location && parsed.lastLocation) {
        parsed.location = {
          label: parsed.lastLocation,
          lat: parsed.lastLat,
          lng: parsed.lastLng,
          source: 'legacy'
        };
      }
      return parsed;
    } catch (e) {
      console.error('Failed to load preferences', e);
      return {};
    }
  },

  set: (prefs: Partial<UserPreferences>) => {
    try {
      const current = storage.get();
      const updated = { ...current, ...prefs };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (e) {
      console.error('Failed to save preferences', e);
    }
  },

  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Failed to clear preferences', e);
    }
  }
};
